<template>
  <div class="dashboard__card" v-cloak>
    <CardLoading v-if="loaders.digitalPromo"></CardLoading>
    <div class="dashboard__card-content" :class="{ 'loadingBlur': loaders.digitalPromo }" v-cloak>
      <div class="dashboard__card-header">
        <div class="dashboard__card-title">Digital Promo <span class="h-italic-text h-helper-text"><a @click.stop="activateModal">(Terms and Conditions)</a></span></div>
        <div class="dashboard__card-title-icon dashboard__card-title-icon--digital-promo"><i class="fa fa-sitemap"></i></div>
      </div>

      <div class="row dashboard__card-body dashboard__card-body--bordered" v-if="totalAvailable" v-cloak>
        <div class="dashboard__grid dash-fuel-funds__content-container">
          <div class="col-sm-7 dashboard__card-body-col dash-fuel-funds__content-col-container">
            <div class="fuel-funds-card__available h-center-align">
              <div class="dash-fuel-funds__total" v-cloak>
                <span class="dash-fuel-funds__dollar-sign h-big-dollar-sign">$</span>{{ totalAvailable }}
              </div>
              <div class="h-available">Available</div>
            </div>
          </div>
          <div class="col-sm-5 dashboard__card-body-col dashboard__card-body-col--shaded dash-fuel-funds__content-col-container">
            <div class="dash-fuel-funds__vendors">
              <div class="dash-fuel-funds__vendor" v-for="webService in webServices">
                <div class="dash-fuel-funds__vendor-percentage h-right-align" v-cloak>${{ parseInt(webService.balance) }}</div>
                <div class="dash-fuel-funds__vendor-name h-left-align" v-cloak>{{ webService.url }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row dashboard__card-body" v-else>
        <div class="alert alert-warning">
          <div class="dashboard__no-data">No Digital Promo information available</div>
        </div>
      </div>
      <div class="dashboard__card-footer">
        <div class="dashboard__card-link" v-if="totalAvailable">
          <router-link to="/digital-promo" class="dashboard__card-link-text">View All</router-link>
        </div>
      </div>
    </div>
    <DigitalPromoTermsModal></DigitalPromoTermsModal>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import DigitalPromoTermsModal from '../../digital-promo/DigitalPromoTermsModal.vue';
  import CardLoading from './CardLoading.vue';

  export default {
    name: 'DigitalPromoCard',
    components: {
      CardLoading,
      DigitalPromoTermsModal,
    },
    mounted() {
      this.$store.dispatch('digitalPromo/getDigitalPromo');
    },
    computed: {
      ...mapGetters('digitalPromo', ['loaders', 'totalAvailable', 'webServices']),
    },
    methods: {
      activateModal() {
        this.$store.dispatch('main/showModal', 'digitalPromoTermsAndConditions');
      },
    }
  };
</script>
